/* eslint-disable */ 

// HIDE
$('#close-video-modal').click(function(e) {
    var $if = $('#myModalhero').find('iframe');
    var src = $if.attr("src");
    $if.attr("src", '/empty.html');
    $if.attr("src", src);    
});

$('#close-caption-video-modal').click(function(e) {
    var $if = $('#myModalCaption').find('iframe');
    var src = $if.attr("src");
    $if.attr("src", '/empty.html');
    $if.attr("src", src);    
});

$('#openCaptionModal').click(function(e) {
    var $if = $('#myModalhero').find('iframe');
    var src = $if.attr("src");
    $if.attr("src", '/empty.html');
    $if.attr("src", src);    
});

$('#close-video-modal').click(function(e) {
    var $if = $('#myModalCaption').find('iframe');
    var src = $if.attr("src");
    $if.attr("src", '/empty.html');
    $if.attr("src", src);    
});
// The following three close the modals on the family research page as it uses static video fields
$('#gs-close-video-modal').click(function(e) {
    var $if = $('#gettingStartedVideo').find('iframe');
    var src = $if.attr("src");
    $if.attr("src", '/empty.html');
    $if.attr("src", src);    
});
$('#cr-close-video-modal').click(function(e) {
    var $if = $('#conductingResearchVideo').find('iframe');
    var src = $if.attr("src");
    $if.attr("src", '/empty.html');
    $if.attr("src", src);    
});
$('#si-close-video-modal').click(function(e) {
    var $if = $('#storiesVideo').find('iframe');
    var src = $if.attr("src");
    $if.attr("src", '/empty.html');
    $if.attr("src", src);    
});

$('.close-video-modal').click(function(e) {
    var buttonId = $(this).data('button-id');
    var $if = $('#' + buttonId).find('iframe');
    var src = $if.attr("src");
    $if.attr("src", '/empty.html');
    $if.attr("src", src);
});

// $('#close-caption-video-modal').click(function(e) {
//     stopOriginalVideo();

// Function to stop the original video
function stopOriginalVideo() {
    var originalVideoPlayer = document.getElementById('player').querySelector('iframe');
    if (originalVideoPlayer) {
        originalVideoPlayer.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
    }
}



// Event listener for the caption modal show event
$('#myModalCaption').on('show.bs.modal', function (e) {
    // Stop the original video before showing the caption modal
    stopOriginalVideo();
});

$('#player-modal').on('show.bs.modal', function (e) {
    // Stop the original video before showing the caption modal
    stopOriginalVideo();
});



/* eslint-enable */ 
